import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Customer } from 'src/model/customer.model';

@Component({
    selector: 'app-enlarge-image',
    templateUrl: './enlarge-image.component.html',
    styleUrls: ['./enlarge-image.component.scss'],
    standalone: false
})
export class EnlargeImageComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private restApi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected sharedService = inject(SharedService);

  @Input() customerId: number;
  @Input() customer: Customer;

  @Input() fileName: string;
  @Input() fileList = [];

  @Input() currentFileIndex: number;

  @Input() isSetFile = false;
  @Input() setId: number;
  @Input() isValidFile: boolean;

  @Input() reserveGroupID: number;

  @Input() blacklistId: number;

  @Output() passEntry = new EventEmitter<any>();

  rotateDegree = 0;

  image: string;

  ngOnInit(): void {
    this.createImageLink();
  }

  createImageLink() {
    if (this.setId != undefined)
      this.image = this.restApi.apiUrl + this.constructApi.getSetFileFull(this.setId, this.fileName);
    else if (this.reserveGroupID != undefined)
      this.image = this.restApi.apiUrl + this.constructApi.getReserveGroupFileFull(this.reserveGroupID, this.fileName);
    else if (this.blacklistId != undefined)
      this.image = this.restApi.apiUrl + this.constructApi.getBlacklistFileFull(this.blacklistId, this.fileName);
    else
      this.image = this.restApi.apiUrl + this.constructApi.getFullFile(this.customerId, this.fileName);
  }

  changePreviousImage() {
    if (this.currentFileIndex - 1 >= 0) {
      this.fileName = this.fileList[--this.currentFileIndex].label;

      this.createImageLink();
    } else
      this.sharedService.openAlert("This is the first image of the list", ALERT_TYPE.DANGER);
  }

  changeNextImage() {
    if (this.currentFileIndex + 1 <= this.fileList.length - 1) {
      this.fileName = this.fileList[++this.currentFileIndex].label;

      this.createImageLink();
    }
    else
      this.sharedService.openAlert("This is the last image of the list", ALERT_TYPE.DANGER);
  }

  checkCanDelete() {
    //branch manager only can delete set documents
    if (this.sharedService.isBranchManager() == true) {
      if (this.setId != undefined) {
        if (this.isValidFile == false)
          return true;
        else
          return false;
      }
      else
        return false;
    }

    // boss account can delete all kinds of documents
    else if (this.sharedService.isBossAccount())
      return true;

    //admin only can delete customer documents
    else if (this.sharedService.isAdmin()) {
      if (this.customerId != undefined)
        return true;
      else
        return false
    }

    //other role not allowed to delete document
    else
      return false;
  }

  confirmDeletePicture() {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "Are you sure you want to delete this picture (" + this.fileName + ") ?";

    modalRef.result.then((confirm) => {
      if (confirm) {
        if (this.isSetFile == false)
          this.deleteImage(this.customerId, this.fileName, undefined);
        else
          this.deleteImage(undefined, this.fileName, this.setId);
      }
    });
  }

  deleteImage(customerId: number, filename: string, setId: number) {
    const encoded = encodeURIComponent(filename);
    let xhttp;
    if (this.isSetFile == false)
      xhttp = this.restApi.deleteRequest(this.constructApi.getDeleteFile(customerId, encoded))
    else if (this.reserveGroupID != undefined)
      xhttp = this.restApi.deleteRequest(this.constructApi.getReserveGroupFileFull(this.reserveGroupID, encoded))
    else
      xhttp = this.restApi.deleteRequest(this.constructApi.getSetFileFull(setId, encoded))

    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4) {
        if (xhttp.status == 200) {
          // Typical action to be performed when the document is ready:
          this.sharedService.openAlert("Successfully deleted picture!", ALERT_TYPE.SUCCESS);
          // window.location.reload();
          this.passEntry.emit(true);
          this.reset();
        }
        else {
          this.sharedService.openErrorMessage(xhttp);
        }
      }
    };
  }

  reset() {
    this.activeModal.close();
  }

  rotate() {
    this.rotateDegree = (this.rotateDegree == 270) ? 0 : this.rotateDegree + 90;
    const rotateStr = "rotate(" + this.rotateDegree + "deg)";
    const img = document.getElementById('enlargedImage');
    img.style.transform = rotateStr
  }
}
